import { DialogTitle } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { CreditEffect } from '@aibees/shared/features/subscription-manager/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { DialogContent, Stack } from '@mui/material';
import { memo, useEffect } from 'react';
import { DialogFooter } from './components/dialog-footer';
import { StatusCard } from './components/status-card';
import { useCreditsInformation } from './hooks/use-credits-information';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentSuccessUpgradeDialogProps as Props } from './types';

export const PaymentSuccessUpgradeDialog = memo(({ className }: Props) => {
  const state = useBoolean();
  const { data } = useCurrentSubscriptionApi();
  const crefitEffect = useCreditsInformation();

  useEffect(() => {
    if (window.location.hash.includes('#successUpgrade')) {
      state.setValue(true);
    }
  }, [window.location.hash]);

  const closeModal = () => {
    window.location.hash = '';
    state.onFalse();
  };

  return (
    <Styled.Wrapper
      open={state.value}
      className={classnames('PaymentSuccessUpgradeDialog', className)}
      sx={SX.root}
      fullWidth={true}
      maxWidth="xs"
      onClose={closeModal}
    >
      <DialogTitle title="🎉 Plan Upgrade Successful" onClose={closeModal} />
      <DialogContent>
        <Stack gap={1}>
          <StatusCard />
          <Stack gap={1} sx={SX.stack}>
            {crefitEffect.map(({ label, value, sx }) => (
              <CreditEffect
                key={label}
                creditAmount={value}
                label={label}
                sx={sx}
              />
            ))}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogFooter onConfirm={closeModal} />
    </Styled.Wrapper>
  );
});

PaymentSuccessUpgradeDialog.displayName = 'PaymentSuccessUpgradeDialog';
